import React, {FC} from 'react';
import styled from 'styled-components';

import {DropdownItemNestedIcon} from '../../../../libs/shared/ui/src/components/dropdowns/items/dropdownItemNestedIcon';
import {Icon} from '../../../../libs/shared/ui/src/components/icon/icon';
import {center} from '../../../../libs/shared/ui/src/styles/mixins';
import {UserThemeConsumer} from '../../../../libs/shared/ui/src/theme/userThemeConsumer';
import {getColorHighlight, getEmojiHighlight} from '../../../helpers/models/highlightHelpers';
import {LensModel} from '../../../models/api/lensModel';
import {Emoji} from '../emoji/emoji';

/*
 * Props.
 */

interface DropdownItemLensIconProps {
  lens: LensModel;
}

/*
 * Style.
 */

const StyledEmojiDiv = styled.div`
  ${center()};
  width: 20px;
`;

/*
 * Component.
 */

export const DropdownItemLensIcon: FC<DropdownItemLensIconProps> = (props) => (
  <DropdownItemNestedIcon nestingLevel={0}>{renderLensIcon(props.lens)}</DropdownItemNestedIcon>
);

function renderLensIcon(lens: LensModel) {
  const emojiAndSkinTone = getEmojiHighlight(lens);

  if (emojiAndSkinTone) {
    return (
      <StyledEmojiDiv>
        <Emoji emoji={emojiAndSkinTone.emoji} skinTone={emojiAndSkinTone.skinTone} size={18} />
      </StyledEmojiDiv>
    );
  }

  const color = getColorHighlight(lens);

  return (
    <UserThemeConsumer>
      {(theme) => (
        <Icon name="savedViewSmall" color={(color && theme.palette[color].shade40) || theme.greys.shade60} />
      )}
    </UserThemeConsumer>
  );
}
